import { css } from '@emotion/react';

export const wrapper1 = css({

    '@media(min-width: 300px)': {
        display: 'block',
        backgroundColor: '#064E72',
        paddingTop: '2%',
        paddingBottom: '2%',
        paddingLeft: '5%',
        paddingRight: '5%',
    },

    '@media(min-width: 1200px)': {
        display: 'none',
        backgroundColor: '#064E72',
        paddingTop: '2%',
        paddingBottom: '2%',
        paddingLeft: '5%',
        paddingRight: '5%',
    },
});

export const wrapper2 = css({
    '@media(min-width: 300px)': {
        display: 'flex',
        backgroundColor: '#064E72',
        width: '100%',
        borderTop: '1px solid #4783A1',
        paddingTop: '3%',
        paddingBottom: '2%',
        paddingLeft: '5%',
        paddingRight: '5%',
    },

    '@media(min-width: 1200px)': {
        display: 'none',
        backgroundColor: '#064E72',
        width: '100%',
        borderTop: '1px solid #4783A1',
        paddingTop: '3%',
        paddingBottom: '2%',
        paddingLeft: '5%',
        paddingRight: '5%',
    },
});

export const cont1 = css({
    display: 'block',
    paddingTop: 20,
});

export const linkWrapper = css({
    '& a': {
        textDecoration: 'none',
        '& p': {
            color: 'white',
            fontSize: '1.1rem',
            fontFamily: 'AcuminRPro',
        },
    },
});

export const GITItems = css({
    display: 'flex',
    gap: 20,

    '& p': {
        color: 'white',
        fontSize: '1.1rem',
        fontFamily: 'AcuminRPro',
    },

});
